import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-edit-client-details",
  templateUrl: "./edit-client-details.component.html",
  styleUrls: ["./edit-client-details.component.css"],
})
export class EditClientDetailsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
